import { render, staticRenderFns } from "./KTCInstallmentPlan.vue?vue&type=template&id=40063995&"
import script from "./KTCInstallmentPlan.vue?vue&type=script&lang=js&"
export * from "./KTCInstallmentPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports